export const routingConfig: Record<string, string> = {
    APP_ERROR: '/app-error',
    ROLE_ASSUMPTION: '/role-assumption',
    DEAL_SETUP: '/deal-setup',
    INVENTORY: '/showroom/inventory',
    VEHICLE_DETAILS: '/showroom/vehicle-details',
    TRADE_IN: '/showroom/trade-in',
    TRADE_IN_TAKEOVER: '/showroom/trade-in/takeover',
    FINANCING: '/showroom/financing',
    CUSTOMER_DETAILS_TAKEOVER: '/showroom/financing/takeover',
    BASE_ROUTE: '/showroom',
    DEAL_SUMMARY: '/showroom/deal-summary',
    DEAL_SUMMARY_ACCEPTED: `/showroom/deal-summary/accepted-deal`,
    DEAL_SUMMARY_DESKED: '/showroom/deal-summary/view-quote',
    DEAL_SUMMARY_SENT: '/showroom/deal-summary/quote-requested',
    DEAL_SUMMARY_REQUEST: '/showroom/deal-summary/request-quote',
    DEAL_SUMMARY_DEAL_PROPOSAL: '/showroom/deal-summary/deal-proposal',
    MANAGE_DOCUMENTS: '/showroom/manage-documents',
    RECENT_DEALS: '/showroom/recent-deals',
    BUILD_YOUR_OFFER: '/showroom/build-your-offer'
};
